<template>
  <div class="my-custom-tab">
    <div class="tab-top">
      <span :class="{active:tabName === 'Comment'}" @click="check('Comment')"><i class="icon iconfont iconicon_comment1"></i>评论</span>
      <span :class="{active:tabName === 'Log'}" @click="check('Log')"><i class="icon iconfont iconicon_log"></i>日志</span>
    </div>
    <div class="tab-content">
      <component
        :taskId="taskId"
        :isdeleted="isdeleted"
        :project_id="project_id"
        @toScorllTop="toScorllTop"
        :disabled="disabled"
        :is="tabName"
      ></component>
    </div>
  </div>
</template>
<script>
import Comment from './comment.vue'
import Log from './log.vue'
export default {
  props: ['taskId', 'isdeleted', 'project_id', 'disabled'],
  components: {
    Comment,
    Log
  },
  data() {
    return {
      tabName: 'Comment'
    }
  },
  methods: {
    check(name) {
      this.tabName = name
    },
    toScorllTop() {
      this.$emit('toScorllTop')
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/mixin.scss";
.my-custom-tab {
  .tab-top {
    font-size: 16px;
    line-height: 1;
    padding-top: 24px;
    padding-bottom: 16px;
    position: sticky;
    top: 0px;
    background-color: #fff;
    z-index: 999;
    span {
      margin-right: 83px;
      color: rgba(32, 32, 32, 0.6);
      cursor: pointer;
    }
    i {
      margin-right: 6px;
      color: rgba(32, 32, 32, 0.6);
    }
    .active {
      color: initial;
      i {
        color: initial;
      }
    }
  }
  .task-comment {
    position: relative;
    // min-height: 400px;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    padding-bottom: 80px;
    .not-msg {
      font-size: 14px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      color: #999;
    }
    .el-textarea__inner {
      border: 0 none;
      padding-right: 26px;
    }
    .nothing-box {
      top: 75px;
      transform: translate(-50%, 0);
    }
  }
  .task-comment-wrap {
    flex: 1;
    overflow: auto;
    padding-bottom: 10px;
  }
  .task-comment-item {
    font-size: 14px;
    line-height: 30px;
    margin-bottom: 24px;
    .more-box {
      font-size: 12px;
      color: $color-active;
      cursor: pointer;
      // margin-left: 39px;
      i {
        font-size: 12px;
        margin-left: 4px;
        transform: rotateZ(0);
        transition: all 0.3s;
      }
      .putDowm {
        transform: rotateZ(180deg);
      }
    }
  }
  .task-comment-item .baseinfo {
    display: flex;
    flex-direction: column;
    line-height: 40px;
    justify-content: space-between;
  }
  .baseinfo_top {
    display: flex;
    justify-content: space-between;
    .name-txt {
      @include fontColorOpacity(.6);
    }
    .user {
      font-size: 16px;
      font-weight: bold;
      color: #202028;
    }
    .date {
      font-size: 14px;
      @include fontColorOpacity(.6);
    }
  }
  .task-comment-item .comment {
    flex: 1;
    line-height: 22px;
    // max-height: 2000px;
    // transition: all 0.3s;
    word-wrap: break-word;
    padding-left: 36px;
  }
  .task-comment-item .comment-rest {
    max-height: 67px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .task-comment-item .person {
    margin-right: 12px;
  }
  .task-comment-input {
    width: 654px;
    display: flex;
    position: fixed;
    bottom: -1px;
    right: 0;
    z-index: 999;
    background-color: #fff;
    min-height: 54px;
    box-sizing: border-box;
    border-top: 1px solid rgba(32, 32, 32, 0.08);
    .button-send {
      flex-shrink: 0;
      width: 70px;
      display: flex;
      align-items: flex-end;
      p {
        cursor: not-allowed;
        height: 32px;
        width: 100%;
        line-height: 32px;
        text-align: right;
        @include fontColorOpacity(.6);
      }
      .iconicon_send_comment {
        margin-left: 4px;
      }
    }
    .button-send-disable p {
      color: $color-active;
      cursor: pointer;
    }
  }
  .task-comment-avatar {
    margin-right: 5px;
    position: relative;
  }
  .task-comment-button {
    position: relative;
    flex: 1;
    display: flex;
    .el-textarea__inner {
      min-height: 32px !important;
      padding: 5px 0 !important;
    }
  }
  .pos-icon {
    cursor: pointer;
    position: absolute;
    font-size: 20px;
    bottom: -3px;
    right: 6px;
    color: #71728e;
    transform: translate(0, -50%);
    &:hover {
      color: $colorStatus-hoverColor;
    }
  }

  // log
  .task-log {
    padding-bottom: 48px;
    position: relative;
    .nothing-box {
      top: 75px;
      transform: translate(-50%, 0);
    }
    .not-msg {
      font-size: 14px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      color: #999;
    }
    .remarks {
      margin-right: 8px;
    }
    .task-log-item {
      font-size: 14px;
      line-height: 22px;
      margin-top: 23px;
      .task-log-item-head {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
      }
      .isRealTask {
        max-width: 84%;
      }
      .message-model {
        padding-left: 36px;
      //   width: 100%;
      //   .message-mixin-wrap {
      //     width: 100%;
      //     display: flex;
      //     .message-mixin-task  {
      //       width: 0;
      //       flex: 1;
      //     }
      //   }
      }
      .message-mixin-tip {
        font-size: 14px;
        @include fontColorOpacity(.6);
        flex-shrink: 0;
      }
    }
    .task-log-item .date {
      @include fontColorOpacity(.6);
      display: flex;
      align-items: center;
      font-size: 12px;
    }
    .task-log-item .person {
      margin-right: 8px;
    }
    .task-log-item .comment {
      margin-right: 4px;
    }
    .task-log-item .info {
      flex: 1;
    }
  }
}
</style>
